import type { DayAheadBidTableResetController } from './DayAheadBidTable.types'

export function createDayAheadBidTableResetController(): DayAheadBidTableResetController {
  const registeredResets = new Map<string, { reset: () => void; registrationId: symbol }>()
  const pendingResets = new Map<string, Set<string>>()
  const acknowledgedResets = new Set<string>()

  function resetKey(contextKey: string, withdrawalId: string): string {
    return `${contextKey}\u0000${withdrawalId}`
  }

  return {
    reset(contextKey, withdrawalId): void {
      const key = resetKey(contextKey, withdrawalId)
      if (acknowledgedResets.has(key)) {
        return
      }

      const registration = registeredResets.get(contextKey)
      if (registration) {
        acknowledgedResets.add(key)
        registration.reset()
        return
      }

      const contextPending = pendingResets.get(contextKey) ?? new Set<string>()
      contextPending.add(withdrawalId)
      pendingResets.set(contextKey, contextPending)
    },
    register(contextKey, reset): () => void {
      const registrationId = Symbol(contextKey)
      registeredResets.set(contextKey, { reset, registrationId })

      const contextPending = pendingResets.get(contextKey)
      if (contextPending) {
        pendingResets.delete(contextKey)
        for (const withdrawalId of contextPending) {
          acknowledgedResets.add(resetKey(contextKey, withdrawalId))
          reset()
        }
      }

      return () => {
        if (registeredResets.get(contextKey)?.registrationId === registrationId) {
          registeredResets.delete(contextKey)
        }
      }
    },
    dispose(): void {
      registeredResets.clear()
      pendingResets.clear()
      acknowledgedResets.clear()
    },
  }
}
